import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-modal';
import { Link } from 'react-router-dom';
import {
  MdArrowForward,
  MdStackedLineChart,
  MdApps,
  MdSwapHoriz,
} from 'react-icons/md';
import { modalOverlayBackgroundColor } from 'util/constants';
// @ts-ignore
import logo from '../../assets/logo.svg';
import './NewExperienceButton.scss';

const MODAL_STYLE = {
  content: {
    margin: '0 auto',
    top: '195px',
    width: '486px',
    height: '500px',
    padding: '35px 48px',
  },
  overlay: {
    background: modalOverlayBackgroundColor,
  },
};

const newItems: { id: string; icon: any; text: string }[] = [
  {
    id: 'bugs',
    icon: <MdApps size={20} color="rgba(0, 0, 0, 0.6)" />,
    text: "Your new hub for your dealership's sales process",
  },
  {
    id: 'function',
    icon: <MdStackedLineChart color="rgba(0, 0, 0, 0.6)" size={20} />,
    text: 'More deal info, features, and new reports',
  },
  {
    id: 'feedback',
    icon: <MdSwapHoriz color="rgba(0, 0, 0, 0.6)" size={20} />,
    text: 'Risk free - you can switch back any time',
  },
];

const NewExperienceButton = () => {
  const [isModalOpen, setOpenModal] = useState(false);
  const toggleModal = () => {
    setOpenModal(!isModalOpen);
  };

  const commandCenterUrl = `${process.env.REACT_APP_COMMAND_CENTER_URL}/?welcome&beta`;
  const modal = (
    <Modal isOpen={isModalOpen} style={MODAL_STYLE} ariaHideApp={false}>
      <div className="new-experience-modal-container">
        <img src={logo} className="logo" alt="Upstart logo" />
        <div className="header">Try the new Upstart Auto Retail</div>
        <div className="desc">
          {'Click "Continue" below to try the new Upstart Auto Retail.'}
        </div>
        <div className="desc">
          {
            "Soon, you'll use the new experience as your hub to manage your dealership's sales process with Upstart."
          }
        </div>
        <div className="desc">
          {
            "For now, don't worry, you can always come back here to the classic website."
          }
        </div>
        <div className="desc-last">What you can expect.</div>
        <div className="new-items">
          {newItems.map(item => (
            <div className="item" key={item.id}>
              {item.icon} {item.text}
            </div>
          ))}
        </div>
        <div className="buttons">
          <Button onClick={toggleModal}>Cancel</Button>
          <Link
            target="_blank"
            className="btn btn-primary btn-blue continue"
            to={{ pathname: commandCenterUrl }}
          >
            Continue <MdArrowForward size={20} />
          </Link>
        </div>
      </div>
    </Modal>
  );

  return (
    <>
      <Button className="btn btn-primary btn-blue" onClick={toggleModal}>
        Try the new website
      </Button>
      {modal}
    </>
  );
};

export default NewExperienceButton;
